import { BuilderTemplateId } from '../builderTemplate';
import { UploadId } from '../upload';
import { PrintProviderId, PrintProviderSKUId } from '../printProvider';
import { ApiRoute, HttpMethod } from '../common';
import { BaseLocationPublishParams } from './publishApiCommon';

export interface ISendToSKUPrintProviderData {
    printProviderSKUId: PrintProviderSKUId;
    orderNumber?: string;
    priceAmount: string;
    priceAmountInCents: number;
    priceCurrency: string;
}

export interface ISendToPrintProviderBody {
    builderTemplateId: BuilderTemplateId;
    documentPagesAmount: number;
    editableTextContent: string[];
    formatHeight: number;
    formatWidth: number;
    instructions: string | null;
    plannerId?: number | null;
    printProviderId: PrintProviderId;
    quantity: number;
    replyEmail: string;
    reviewedArtwork: boolean;
    shippingAttention: string | null;
    shippingCompanyName: string | null;
    shippingLineOne: string | null;
    shippingLineThree: string | null;
    shippingLineTwo: string | null;
    skuData?: ISendToSKUPrintProviderData | null;
    uploadId: UploadId;
}

export const PublishPrintApi = {
    sendToPrintProvider: new ApiRoute<void, BaseLocationPublishParams, ISendToPrintProviderBody, void>(
        HttpMethod.Post,
        path => path.literal('publish').literal('print').literal('location').param('locationId'),
    ),
};
